// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Anwesenheit, MyAnwesenheitDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateMeineAnwesenheit(): (
  anwesenheitId: string,
  requestBody: MyAnwesenheitDaten
) => Promise<Anwesenheit> {
  const getAPI = useGetApi();
  return useCallback(
    async (anwesenheitId, requestBody) =>
      (await getAPI()).anwesenheiten.updateMeineAnwesenheit({
        anwesenheitId,
        requestBody,
      }),
    [getAPI]
  );
}
